<ion-app>
  <ion-router-outlet></ion-router-outlet>
</ion-app>

<!-- Corner Ribbon -->
<div class="corner-ribbon top-right sticky orange" *ngIf="devEnvironment">DEV</div>
<div class="corner-ribbon top-right sticky white" *ngIf="demoEnvironment">DEMO</div>
<!-- <div class="corner-ribbon top-right sticky red shadow" *ngIf="uatEnvironment">UAT-β</div> -->
